import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** In-tab pub/sub so dashboard tiles (or anything else) can refetch after a staff message action changes
 * state elsewhere - no payload needed, every signal just means "some tile's numbers may be stale." Only
 * reaches subscribers in this same browser tab; doesn't sync across tabs or staff members. */
@Injectable({
  providedIn: 'root'
})
export class StaffMessageEventsService {
  private readonly changed = new Subject<void>();
  readonly changed$ = this.changed.asObservable();

  notifyChanged(): void {
    this.changed.next();
  }
}
